// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"b4fd0bfa","502":"dec4c112","2220":"beaf8169","2531":"7eec7d29","2834":"77fc87fc","3786":"940ba2f0","7304":"beaf8169","7963":"dc19f313","8581":"3db04ccb"}[chunkId] + ".chunk.css";
};